import { currentOrderUuid, nextPosOrderNumber } from '../utils/orderNumbers'

// PERSISTED

// NON PERSISTED

export const getCurrentOrderNumber = (state) => {
  return nextPosOrderNumber()
}

export const getCurrentOrderUuid = (state) => {
  return currentOrderUuid()
}

export const getOrderNumberMin = (state) => {
  return state.VNInvoiceManager.get('orderNumberMin')
}

export const getOrderNumberMax = (state) => {
  return state.VNInvoiceManager.get('orderNumberMax')
}
